<template>
  <div v-if="!noView" class="tq-iframe-wrapper" v-loading="loading" element-loading-text="加载中..." ref="iframeWrapper">
    <iframe v-if="iframeSrcUrl" @load="hasLoadedPage"  allow="fullscreen" :src="iframeSrcUrl" frameborder="0" width="100%" height="100%"></iframe>
    <div class="error-msg" v-if="errMsg">{{ errMsg }}</div>
  </div>
</template>

<script lang="ts">
import { getIframeUrlFromBigData } from "../../../service/bigData"
export default {
  name: "TqIframe",
  data() {
    return {
      loading: true,
      iframeSrcUrl: '',
      errMsg: '',
    }
  },
  props: {
    // 是否是用文件名换url
    isFileName: {
      type: Boolean,
      require: true,
      default: false
    },
    // 是否使用文件id换url
    isFileId: {
      type: Boolean,
      require: true,
      default: false
    },
    // 无需视图
    noView: {
      type: Boolean,
      default: false
    },
    // 文件名
    fileName: {
      type: String,
      default: ''
    },
    // 文件id
    fileId: {
      type: String,
      default: ''
    },
    // 接口参数
    reportParam: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    // 获取url的接口
    getUrlApi() {
      if (this.isFileName) {
        return `/fine/getUrlByName`
      } else if (this.isFileId) {
        return `/fine/getUrlById`
      }
      return `/fine/getUrlByName`
    }
  },
  methods: {
    hasLoadedPage(event:any) {
      this.loading = false
      this.$emit('loaded-iframe', event)
    },
    toggleFullScreen() {
      (this.$refs.iframeWrapper as any).requestFullscreen()
    },
  },
  watch: {
    fileName: {
      handler: function (val) {
        if (val && this.isFileName) {
          this.loading = true
          getIframeUrlFromBigData(this.getUrlApi, {
            reportName: val,
            reportParam: {
              ...this.reportParam
            }
          }).then((res:any) => {
            if (res.msgCode === '100') {
              this.iframeSrcUrl = res.responseData
              this.errMsg = ""
              this.$emit('get-success', this.iframeSrcUrl)
            } else {
              this.errMsg = res.message || '获取大数据报表url失败'
              this.loading = false
              this.$emit('get-fail', res)
            }
          }).catch((err:any) => {
            this.errMsg = '获取大数据报表url失败'
            this.loading = false
            console.log('get url bid data err', err);
            this.$emit('get-fail',err)
          })
        }
      },
      immediate: true
    },
    fileId: {
      handler: function (val) {
        if (val && this.isFileId) {
          this.loading = true
          getIframeUrlFromBigData(this.getUrlApi, {
            reportId: val,
            reportParam: {
              ...this.reportParam
            }
          }).then((res:any) => {
            if (res.msgCode === '100') {
              this.iframeSrcUrl = res.responseData
              this.errMsg = ""
              this.$emit('get-success', this.iframeSrcUrl)
            } else {
              this.errMsg = res.message || '获取大数据报表url失败'
              this.loading = false
              this.$emit('get-fail', res)
            }
          }).catch((err:any) => {
            this.errMsg = '获取大数据报表url失败'
            this.loading = false
            console.log('get url bid data err', err);
            this.$emit('get-fail', err)
          })
        }
      },
      immediate: true
    },
  },
  mounted() {

  }
}
</script>

<style>
.error-msg {
  color: #F52F3E;
}
</style>